import styled from 'styled-components'

const StyledRangePicker = styled.div`
  .DayPicker_transitionContainer__horizontal {
    height: 380px !important;
  }

  input[type='text']:not(.browser-default) {
    font-size: 1.4rem;
  }

  .DateRangePicker_picker {
    z-index: 10;
    position: absolute;
  }

  .DateInput_input {
    text-align: center;
    color: black;
    font-size: 1.4rem;

    ::placeholder {
      color: #484848;
    }
  }

  .DateInput_input__small {
    font-size: 1.4rem;
    line-height: 10px;
    padding: 1px 4px 1px;
  }

  .DateInput_input__focused {
    border-bottom: 2px solid black;
  }

  .DateRangePickerInput_arrow {
    display: inline-block;
    vertical-align: center;
    color: #484848;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .DateRangePickerInput__withBorder {
    border-radius: 2px;
    border: 1px solid #dbdbdb;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 24rem;
  }

  .DateRangePickerInput_clearDates {
    margin: 4px 0px 1rem 3px;
    top: 0%;
    transform: translateY(-13%);
    &:hover {
      background: transparent;
    }
  }

  .DateRangePickerInput_clearDates_svg {
    &:hover {
      fill: black;
    }
  }

  .DayPicker_weekHeader {
    color: black;
  }

  .DayPickerNavigation_button__default {
    background-color: transparent;
    border: none;
    color: #757575;
    &:hover {
      border: none;
    }
  }

  .DayPickerNavigation_svg__horizontal {
    fill: black;
    height: 20px;
    width: 20px;
    &:hover {
      border: none;
      border-bottom: 1px solid black;
    }
  }

  .CalendarMonth_caption {
    color: black;
  }

  .CalendarDay__default,
  .CalendarDay__outside {
    border: 1px solid #e4e7e7;
    color: #6c757d;
    background: white;
    border: none;
  }

  .CalendarDay:hover {
    background: #39afd1;
    color: white;
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: #464f5b;
    color: white;
  }

  .CalendarDay__selected_span {
    background: #f3f6f9;
    color: black;
    border: none;
    &:hover {
      background: rgba(15, 130, 197, 1);
      border: none;
    }
  }

  .CalendarDay__selected {
    background: rgba(15, 130, 197, 1);
    border: none;
    color: white;
  }

  .CalendarDay__selected:hover {
    background: rgba(15, 130, 197, 1);
    color: white;
  }

  .CalendarDay__hovered_span:hover,
  .CalendarDay__hovered_span {
    background: #f3f6f9;
    color: black;
    border: none;
  }

  .CalendarDay__blocked_calendar {
    background: #f3f6f9;
    color: black;
    cursor: not-allowed;
  }
`

export default StyledRangePicker
